import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: 'topup'
  },
  {
    path: '/v5pay',
    component: () => import('./view/order/v5payConfirm'),
    meta: {
      title: 'AboutUs',
      isLogin: false
    }
  },
  {
    path: '/aboutUs',
    component: () => import('./view/additional/AboutUs'),
    meta: {
      title: 'AboutUs',
      isLogin: false
    }
  },
  {
    path: '/contactUs',
    component: () => import('./view/additional/ContactUs'),
    meta: {
      title: 'ContactUs',
      isLogin: false
    }
  },
  {
    path: '/privacy',
    component: () => import('./view/additional/PrivacyPolicy'),
    meta: {
      title: 'PrivacyPolicy',
      isLogin: false
    }
  },
  {
    path: '/refundPolicy',
    component: () => import('./view/additional/RefundPolicy'),
    meta: {
      title: 'RefundPolicy',
      isLogin: false
    }
  },
  {
    path: '/termsService',
    component: () => import('./view/additional/TermsService'),
    meta: {
      title: 'TermsService',
      isLogin: false
    }
  },
  {
    path: '/topup',
    component: () => import('@/view/index/home'),
    meta: {
      title: '首页',
      showTabBar: true
    }
  },
  {
    path: '/packagePurchase',
    component: () => import('@/view/index/packagePurchase'),
    meta: {
      title: '套餐购买',
      showTabBar: true
    }
  },
  {
    path: '/couponRedeem',
    component: () => import('@/view/index/couponRedeem'),
    meta: {
      title: 'Coupon',
      showTabBar: true
    }
  },
  {
    path: '/order',
    component: () => import('@/view/order/index'),
    meta: {
      title: '订单',
      showTabBar: false
    }
  },
  {
    path: '/paymentOrder',
    component: () => import('@/view/index/paymentOrder'),
    meta: {
      title: '付款摘要',
      showTabBar: true
    }
  },
  {
    path: '/orderCancel',
    component: () => import('@/view/order/cancel'),
    meta: {
      title: '取消',
      showTabBar: false
    }
  },
  {
    path: '/paySuccess',
    component: () => import('@/view/order/success'),
    meta: {
      title: '成功',
      showTabBar: false
    }
  },
  {
    path: '/queryAntomTransaction',
    component: () => import('@/view/order/success'),
    meta: {
      title: '成功',
      showTabBar: false
    }
  },
  {
    path: '/subscribeRule',
    component: () => import('./view/additional/Subscription'),
    meta: {
      title: 'Subscribe',
      isLogin: false
    }
  },
  {
    path: '/subscribeResult',
    component: () => import('./view/subscribe/antomSubscribePage'),
    meta: {
      title: 'Subscribe Result',
      isLogin: false
    }
  },
  {
    path: '/trialActivation',
    component: () => import('@/view/trialActivation/index'),
    meta: {
      title: '体验套餐',
      isLogin: false
    }
  },
  {
    path: '/unlock',
    component: () => import('@/view/unlock/index'),
    meta: {
      title: '解锁',
      isLogin: false
    }
  },
  {
    path: '/paymentInfo',
    component: () => import('@/view/unlock/paymentInfo'),
    meta: {
      title: '付款摘要',
      isLogin: false
    }
  },
  {
    path: '/paymentSuccess',
    component: () => import('@/view/unlock/paymentSuccess'),
    meta: {
      title: '支付成功',
      isLogin: false
    }
  },
  {
    path: '/unlockOrderResult',
    component: () => import('@/view/unlock/paymentResult'),
    meta: {
      title: '支付中....',
      isLogin: false
    }
  },
  {
    path: '/feedback',
    component: () => import('@/view/Feedback/index'),
    meta: {
      title: 'Feedback',
      isLogin: false
    }
  },
  {
    path: '/feedback/issue',
    component: () => import('@/view/Feedback/issueSelect'),
    meta: {
      title: 'Feedback',
      isLogin: false
    }
  },
  {
    path: '/feedback/history',
    component: () => import('@/view/Feedback/ticketHistory'),
    meta: {
      title: 'Feedback',
      isLogin: false
    }
  },
  {
    path: '/feedback/form',
    component: () => import('@/view/Feedback/form'),
    meta: {
      title: 'Feedback',
      isLogin: false
    }
  },
  {
    path: '/feedback/success',
    component: () => import('@/view/Feedback/success'),
    meta: {
      title: 'Feedback',
      isLogin: false
    }
  }
];

// const router = new VueRouter({
//   mode: 'hash',
//   routes
// });
const router = new VueRouter({
  mode: 'hash',
  // base: process.env.BASE_URL,
  routes
});

export default router;
